import { createSlice } from '@reduxjs/toolkit';

import { setAccessToken } from './auth-actions';
import {
  forgotPasswordThunk,
  quickSignUpThunk,
  resetPasswordThunk,
  signInThunk,
  signOutThunk,
  signUpThunk,
} from './auth-thunks';

type AuthStateType = {
  accessToken: string | null;
  isLoading: boolean;
};

const initialState: AuthStateType = {
  accessToken: '',
  isLoading: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // setAccessToken: (store, action) => {
    //   console.log('setAccessToken::called');
    //   store.accessToken = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(setAccessToken, (state, action) => {
      state.accessToken = action.payload;
    });
    builder.addCase(signUpThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(signUpThunk.fulfilled, (store) => {
      store.isLoading = false;
    });
    builder.addCase(signUpThunk.rejected, (store) => {
      store.isLoading = false;
    });

    builder.addCase(quickSignUpThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(quickSignUpThunk.fulfilled, (store, action) => {
      store.accessToken = action.payload?.access_token || '';
      store.isLoading = false;
    });
    builder.addCase(quickSignUpThunk.rejected, (store) => {
      store.isLoading = false;
    });

    builder.addCase(signInThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(signInThunk.fulfilled, (store, action) => {
      store.accessToken = action.payload?.access_token || '';
      store.isLoading = false;
    });
    builder.addCase(signInThunk.rejected, (store) => {
      store.isLoading = false;
    });

    builder.addCase(signOutThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(signOutThunk.fulfilled, (store) => {
      store.isLoading = false;
    });
    builder.addCase(signOutThunk.rejected, (store) => {
      store.isLoading = false;
    });

    builder.addCase(forgotPasswordThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(forgotPasswordThunk.fulfilled, (store) => {
      store.isLoading = false;
    });
    builder.addCase(forgotPasswordThunk.rejected, (store) => {
      store.isLoading = false;
    });

    builder.addCase(resetPasswordThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(resetPasswordThunk.fulfilled, (store) => {
      store.isLoading = false;
    });
    builder.addCase(resetPasswordThunk.rejected, (store) => {
      store.isLoading = false;
    });
  },
});

export default authSlice.reducer;
